import { useFormikContext } from 'formik';
import Spacer from '@antimatterhq/ui/components/spacer';
import { Text } from '@antimatterhq/ui/components/typography';
import { Switch } from '@antimatterhq/ui/components/switch';
import {
  ProcessingScheduleRadioGroup,
  ComputeResourcesRadioGroup,
} from '@/components/radio';
import { ProcessingScheduleSchemaFormValues } from '@/zod/schemas/ProcessingScheduleSchema';
import { ComputeGroupSchemaFormValues } from '@/zod/schemas/ComputeGroupSchema';

export const TransformProcessingScheduleForm = () => {
  const { values, handleChange, handleBlur, touched, errors, setFieldValue } =
    useFormikContext<
      ProcessingScheduleSchemaFormValues &
        ComputeGroupSchemaFormValues & { enabled: boolean }
    >();

  return (
    <>
      <ProcessingScheduleRadioGroup
        handleChange={handleChange}
        values={values}
        errors={errors}
        touched={touched}
        handleBlur={handleBlur}
      />

      <Spacer size="lg" />

      <Text size="base" bold className="mb-2 mt-4 block">
        Compute resources
      </Text>

      <div className="max-w-form">
        <ComputeResourcesRadioGroup
          handleChange={handleChange}
          values={values}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
        />
      </div>

      <Spacer size="lg" />

      <Text size="base" bold>
        Enable rule
      </Text>

      <Spacer size="lg" />

      <div className="flex items-center gap-2">
        <Switch
          checked={values.enabled}
          onCheckedChange={(value) => setFieldValue('enabled', value)}
        />
        <Text size="sm">Enabled</Text>
      </div>
    </>
  );
};
